import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initFeatureBg() {
  const features = document.querySelectorAll('.feature[data-bg]');
  features.forEach((section) => {
    const bg = section.dataset.bg;
    section.style.setProperty('--feature-bg', bg);
    section.style.background = 'var(--feature-bg)';
  });
}
